<template>

	<div class="result-container">

		<img :src="result.imagem" class="battery">

		<div>
			<h2 :class="result.class">{{result.titulo}}</h2>

			<p v-html="result.mensagem"></p>

			<div v-if="!isSaved">
				<div class="form-check form-check-inline" style="display:block;">
						<input class="form-check-input" type="checkbox" v-model="newsletter" name ="newsletter" id="newsletter">
						<label class="form-check-label" for="newsletter">Desejo receber e-mails informativos, novidades, promoções e atualizações</label>
				</div>

				<button class="btn btn-primary" style="margin-top: 1rem;" v-if="newsletter" @click="onEnviarClick">Enviar</button>
			</div>

		</div>

	</div>

</template>

<script>

export default {
	name: "Resultado",
	props: ['resultado', 'contato'],
	data () {
		return {
			porcentagem: null,
			newsletter: false,
			isSaved: false,
			critico: {
				titulo: 'Crítico',
				mensagem: 'Detectamos problemas críticos no seu conhecimento em gestão e no desempenho do seu negócio. É preciso agir com a máxima urgência para recuperar o seu negócio. Nossos treinamentos te ajudarão a identificar as falhas na gestão do seu negócio e a melhorar o seu desempenho. <a href="/solucoes" class="link-questionario">Clique aqui</a> para conhecer nossas soluções.',
				imagem: '/img/bateria-critico.png',
				class: 'critico'
			},
			preocupante: {
				titulo: 'Preocupante',
				mensagem: 'O seu conhecimento em gestão e o desempenho do seu negócio estão preocupantes. É preciso agir o mais rápido possível para eliminar as falhas. Nossos treinamentos te ajudarão a identificar as falhas na gestão do seu negócio e a melhorar o seu desempenho. <a href="/solucoes" class="link-questionario">Clique aqui</a> para conhecer nossas soluções.',
				imagem: '/img/bateria-perocupante.png',
				class: 'preocupante'
			},
			regular: {
				titulo: 'Regular',
				mensagem: 'O seu conhecimento em gestão e o desempenho do seu negócio estão regulares. Para atingir o nível excelente, é importante manter o foco nos processos críticos do seu negócio. Nossos treinamentos te ajudarão a identificar as falhas na gestão do seu negócio e a melhorar o seu desempenho. <a href="/solucoes" class="link-questionario">Clique aqui</a> para conhecer nossas soluções.',
				imagem: '/img/bateria-regular.png',
				class: 'regular'
			},
			bom: {
				titulo: 'Bom a excelente',
				mensagem: 'Parabéns! O seu conhecimento em gestão e o desempenho do seu negócio estão muito  bons. Para manter os bons resultados alcançados e buscar melhorar ainda mais e continuamente a gestão do seu negócio, <a href="/solucoes" class="link-questionario">Clique aqui</a> e conheça nossas soluções.',
				imagem: '/img/bateria-bom.png',
				class: 'bom'
			},
			result: null,
		}
	},
	methods: {
		onEnviarClick () {
			axios.post('/newsletter', {
				email: this.contato.email,
				nome: this.contato.nome,
				newsletter: this.newsletter
			}).then(response => {
				//console.log(response);
				this.isSaved = true;
			}).catch(error => {
				console.log(error.message);
			})
		}
	},
	created () {
		this.porcentagem = (this.resultado * 100)/40; console.log(this.porcentagem);

		if (this.porcentagem <= 30)
			this.result = this.critico;
		if (this.porcentagem <= 50 && this.porcentagem > 30)
			this.result = this.preocupante;
		if (this.porcentagem <= 70 && this.porcentagem > 50)
			this.result = this.regular;
		if (this.porcentagem >= 71)
			this.result = this.bom;
	}
}
</script>

<style scoped>

</style>
